/**
 * ISO-дедлайн через N секунд от текущего момента.
 */
export const untilFromSeconds = (seconds: number): string =>
  new Date(Date.now() + seconds * 1000).toISOString();
